import { message } from "antd";

const useCopy = () => {
  // handle copy clipboard
  const handleCopy = (text: string | undefined) => {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        message.success(`কপি করা হয়েছে: ${text}`);
      });
    }
  };

  return handleCopy;
};

export default useCopy;
